export const DISCORD_LINK = "https://discord.gg/hmg6ZhkuhT"
export const TWITTER_LINK = "https://twitter.com/JazzHeroes"
export const INSTAGRAM_LINK = "https://www.instagram.com/jazz.heroes"
export const INSTAGRAM_RUDY_LINK ="https://www.instagram.com/rudygobert27"
export const TACT_STUDIO_LINK ="https://www.tact-studio.com/"
export const SMART_CHAIN_LINK ="https://smart-chain.fr"
export const WEBSITE_LINK ="https://www.jazzheroes.io/"
export const COINZOOM_LINK = "https://nft.coinzoom.com/"
